import { API_BASE_URL } from '../constants/api';

const API_ORIGIN = API_BASE_URL.replace('/api/v1', '');

export interface ProductoImagen {
  id: string;
  productoId: string;
  url: string;
  orden: number;
  creadoEn: string;
}

export function getProductImageUrl(url: string): string {
  if (!url) return '';
  if (url.startsWith('http')) return url;
  return `${API_ORIGIN}${url}`;
}

export function getFirstProductImage(imagenes?: ProductoImagen[]): string {
  if (!imagenes || imagenes.length === 0) return '';
  return getProductImageUrl(imagenes[0].url);
}
